export default __webpack_public_path__ + "static/30783-709e716f87221613ad4ef52c6d6a45aa.jpg";